// shared menu system — burger overlay wheel + cart drawer + search
// used by index.html, hero2.html and every pdp-hero page (all guarded: missing markup = no-op)
//
// THEME COPY - two blocks differ from site/js/menu.js on purpose (parity pass, 21 Sep), both marked "THEME COPY":
// the search index points at the store's URLs and the products' own images (it shipped the static
// file names, so every search result was a 404), and "You are here" compares full paths.
(function(){
  var burger = document.getElementById('navBurger');
  var menu = document.getElementById('mobileMenu');
  if(!burger || !menu) return;
  function setMenu(open){
    menu.classList.toggle('open', open);
    burger.setAttribute('aria-expanded', open);
  }
  burger.addEventListener('click', function(){ setMenu(!menu.classList.contains('open')); });
  var mc = document.getElementById('menuClose');
  if(mc) mc.addEventListener('click', function(){ setMenu(false); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') setMenu(false); });
  menu.addEventListener('click', function(e){ if(e.target.tagName === 'A') setMenu(false); });
})();
(function(){
  var cart = document.getElementById('cartDrawer'), cartCatch = document.getElementById('cartCatch');
  var btn = document.getElementById('cartBtn'), close = document.getElementById('cartClose');
  if(!cart || !cartCatch || !btn || !close) return;
  function setCart(open){
    cart.classList.toggle('open', open);
    cartCatch.classList.toggle('open', open);
  }
  btn.addEventListener('click', function(e){ e.preventDefault(); setCart(true); });
  close.addEventListener('click', function(){ setCart(false); });
  cartCatch.addEventListener('click', function(){ setCart(false); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') setCart(false); });
})();
// OptionWheel — vanilla port (no loop, all options in frame, hover = focus/sharp)
(function(){
  var root = document.getElementById('menuWheel');
  if(!root) return;
  var els = Array.prototype.slice.call(root.querySelectorAll('.ow-item'));
  var N = els.length;
  var pos = (N-1)/2, target = pos, raf = null, hovered = -1, selectedMode = false;

  function rowH(){
    return Math.max((root.clientHeight * 0.85) / N, 1);   // spread across full frame height
  }
  var locked = false;
  function frame(now){
    pos += (target - pos) * 0.09;                    // same easing as hero carousel
    var settled = Math.abs(target - pos) < 0.001;
    if(settled){ pos = target; locked = false; }
    var rh = rowH();
    var CENTER = (N-1)/2;
    for(var i=0;i<N;i++){
      var d = i - pos;                               // focus distance (drives blur only)
      var el = els[i];
      el.style.transform = 'translateY(calc(' + ((i-CENTER)*rh).toFixed(2) + 'px - 50%))'; // FIXED slots
      // binary focus: hovered (or settled center when nothing hovered) = sharp, rest blurred
      var focus = (hovered > -1) ? (i === hovered) : (selectedMode && Math.abs(d) < 0.5);
      el.style.opacity = focus ? '1' : '0.55';
      el.style.filter = focus ? 'none' : 'blur(0.25rem)';
      el.classList.toggle('selected', focus);
    }
    raf = settled ? null : requestAnimationFrame(frame);
  }
  function start(){ if(raf==null){ raf = requestAnimationFrame(frame); } }
  function go(v, snap){
    v = Math.min(Math.max(v, 0), N-1);              // clamp — no infinite loop
    target = snap ? Math.round(v) : v;
    start();
  }


  // Nº index + tick trio above each label (v4) + originkit text roll
  els.forEach(function(el, i){
    var labelText = el.textContent.trim();
    el.textContent = '';
    var num = document.createElement('span');
    num.className = 'ow-num';
    num.innerHTML = 'N\u00BA 0' + (i+1) + ' <i class="ow-tick"></i>';
    var roll = document.createElement('span'); roll.className = 'ow-roll';
    var inner = document.createElement('span'); inner.className = 'ow-roll-inner';
    var a = document.createElement('span'); a.className = 'a'; a.textContent = labelText;
    var b = document.createElement('span'); b.className = 'b'; b.textContent = labelText;
    inner.appendChild(a); inner.appendChild(b); roll.appendChild(inner);
    el.appendChild(num); el.appendChild(roll);
  });

  // fixed right-side reveal
  var reveal = document.getElementById('menuReveal');
  var revealImg = document.getElementById('revealImg');
  function showReveal(i){
    if(i < 0){ reveal.classList.remove('show'); return; }
    var el = els[i], src = el.getAttribute('data-img');
    if(!src){ reveal.classList.remove('show'); return; }
    reveal.style.top = 'calc(50% + ' + ((i - (N-1)/2) * rowH()).toFixed(1) + 'px)';  // level with its item
    revealImg.classList.toggle('inverted', el.getAttribute('data-invert') === '1');
    if(revealImg.getAttribute('src') !== src){
      reveal.classList.remove('show');
      setTimeout(function(){ revealImg.setAttribute('src', src); reveal.classList.add('show'); }, 120);
    } else {
      reveal.classList.add('show');
    }
  }

  // hover sharpens in place — movement only via wheel / keys / drag
  els.forEach(function(el, i){
    el.addEventListener('mouseenter', function(){ hovered = i; showReveal(i); start(); });
    el.addEventListener('mouseleave', function(){ hovered = -1; showReveal(selectedMode ? Math.round(target) : -1); start(); });
    el.addEventListener('click', function(e){ if(dragMoved) e.preventDefault(); });
  });

  // scroll wheel — bind on the DRAWER so it works anywhere in the menu
  document.getElementById('mobileMenu').addEventListener('wheel', function(e){
    e.preventDefault();
    if(locked || Math.abs(e.deltaY) < 4) return;    // one option per gesture (carousel dynamics)
    hovered = -1; selectedMode = true;
    locked = true;
    go(Math.round(target) + (e.deltaY > 0 ? -1 : 1), true);   // scroll up = up the list
    showReveal(Math.round(target));
  }, {passive:false});

  root.addEventListener('keydown', function(e){
    var d = null;
    if(e.key==='ArrowUp'||e.key==='ArrowLeft') d=-1;
    else if(e.key==='ArrowDown'||e.key==='ArrowRight') d=1;
    if(d==null) return;
    e.preventDefault();
    hovered = -1; selectedMode = true;              // keys = explicit selection
    go(Math.round(target)+d, true);
    showReveal(Math.round(target));
  });


  // "You are here" marker on the option matching current location (path or #hash)
  function markHere(){
    els.forEach(function(el){
      var old = el.querySelector('.ow-here'); if(old) old.remove();
      el.classList.remove('is-here');
      var href = el.getAttribute('href') || '';
      var here = false;
      if(href.charAt(0) === '#') here = href.length > 1 && href === location.hash;
      // THEME COPY: store links are absolute paths (/collections/epos), not file names
      else if(window.Shopify && window.Shopify.shop) here = href.split('#')[0] === location.pathname;
      else here = href.split('#')[0] === location.pathname.split('/').pop();
      if(here){
        el.classList.add('is-here');
        var s = document.createElement('span');
        s.className = 'ow-here';
        s.textContent = '\u21B3 You are here.';
        el.appendChild(s);
      }
    });
  }
  window.addEventListener('hashchange', markHere);
  markHere();

  // click-drag up/down
  var drag = null, dragMoved = false;
  root.addEventListener('pointerdown', function(e){
    drag = {y:e.clientY, start:target, id:e.pointerId}; dragMoved = false;
  });
  root.addEventListener('pointermove', function(e){
    if(!drag) return;
    var dy = e.clientY - drag.y;
    if(!dragMoved && Math.abs(dy)>4){ dragMoved = true; root.setPointerCapture(drag.id); hovered = -1; selectedMode = true; }
    if(dragMoved) go(drag.start - dy/rowH(), false);
  });
  function endDrag(){
    if(!drag) return;
    drag = null;
    if(dragMoved) go(target, true);
    setTimeout(function(){ dragMoved = false; }, 0);
  }
  root.addEventListener('pointerup', endDrag);
  root.addEventListener('pointercancel', endDrag);
  // click empty menu background = deselect, back to all-blurred rest
  root.addEventListener('click', function(e){
    if(e.target === root && !dragMoved){ selectedMode = false; hovered = -1; showReveal(-1); start(); }
  });

  // v459 (Faiz, 25 Sep): the blur is a HOVER effect, and a touch device never hovers - so on a phone
  // the wheel opened with all ten rows blurred and stayed that way until the visitor happened to drag.
  // Desktop keeps the untouched all-blurred open exactly as it was; touch opens with the centre row
  // sharp, which is the same state a mouse user reaches the moment they move the pointer.
  var NO_HOVER = window.matchMedia && window.matchMedia('(hover: none)').matches;
  document.getElementById('navBurger').addEventListener('click', function(){
    selectedMode = NO_HOVER; hovered = -1;           // fresh open = untouched state, all blurred
    target = pos = (N-1)/2;
    showReveal(-1);
    setTimeout(start, 50); root.focus(); markHere();
  });
  window.addEventListener('resize', start);
  start();
})();

// Search overlay — blur page, centered bar, live suggestions + inline autofill
(function(){
  var overlay = document.getElementById('searchOverlay');
  var input = document.getElementById('searchInput');
  var ghost = document.getElementById('searchGhost');
  var list = document.getElementById('searchSuggest');
  if(!overlay) return;

  var INDEX = [
    {t:'Midsea Murmur', k:'perfume epos daily fresh marine woody', type:'Epos', href:'pdp-hero-midsea-murmur.html', img:'img/midsea-murmur.rgba.png', d:'The Daily Signature \u2014 fresh marine that lands in warm wood.'},
    {t:'Divine Dilemma', k:'perfume epos compliment citrus amber musk', type:'Epos', href:'pdp-hero-divine-dilemma.html', img:'img/divine-dilemma.rgba.png', d:'The Compliment Getter \u2014 bright citrus into soft amber musk.'},
    {t:'Crown Cardinal', k:'perfume epos authority oud spiced', type:'Epos', href:'pdp-hero-crown-cardinal.html', img:'img/crown-cardinal.rgba.png', d:'The Authority Stamp \u2014 fruity citrus into spiced royal oud.'},
    {t:'Black Sunset', k:'perfume epos smoky oud night', type:'Epos', href:'pdp-hero-black-sunset.html', img:'img/black-sunset.rgba.png', d:'The Last Impression \u2014 cool spice into smoky oud.'},
    {t:'Rich Reverie', k:'perfume epos coffee vanilla gourmand night', type:'Epos', href:'pdp-hero-rich-reverie.html', img:'img/rich-reverie.rgba.png', d:'The Night Magnet \u2014 fruity florals into creamy vanilla.'},
    {t:"Rose O'Clock", k:'perfume epos rose floral romantic', type:'Epos', href:'pdp-hero.html', img:'img/rose-oclock.rgba.png', d:'The Romantic Signature \u2014 bright fruit into a blooming rose.'},
    {t:'Oud of the Ocean', k:'perfume oud aquatic marine', type:'Oud', href:'pdp-hero-oud-of-the-ocean.html', img:'img/oud-of-the-ocean.rgba.png', d:'A genuine aquatic oud, built for every Indian season.'},
    {t:'Oud of the Storm', k:'perfume oud dark extrait night', type:'Oud', href:'pdp-hero-oud-of-the-storm.html', img:'img/oud-of-the-storm.rgba.png', d:'The Maison\u2019s statement extrait \u2014 after dark, and it stays.'},
    {t:'Saharan Spice', k:'perfume cristallo warm spicy woody', type:'Cristallo', href:'pdp-hero-saharan-spice.html', img:'img/saharan-spice.rgba.png', d:'Desert warmth \u2014 dry spice, no sugar.'},
    {t:'Silk Blush', k:'perfume cristallo soft floral', type:'Cristallo', href:'pdp-hero-silk-blush.html', img:'img/silk-blush.rgba.png', d:'Soft luxury \u2014 silk, worn as a scent.'},
    {t:'Discovery Set', k:'trial samples 5ml six set 1949', type:'Set', href:'collection-discovery.html', img:'img/discovery-set.png', d:'All six of Act I in 5ml \u2014 the surest first step. \u20B91,949.'},
    {t:'Gifts & Sets', k:'gift corporate present', type:'Shop', href:'collection-gifting.html', img:'img/epos-box.png', d:'Boxed to be opened in front of people.'},
    {t:'Dyadic Olfaction', k:'mechanic two scents morph technology', type:'House', href:'dyadic-olfaction.html', img:'', d:'Two fragrances in a single wear \u2014 the house\u2019s own mechanic.'},
    {t:'About Maison Monzzaro', k:'story brand maison mr monzzaro', type:'House', href:'maison.html', img:'', d:'The art of being \u2014 the story of the house.'},
    {t:'Shipping & Returns', k:'delivery free returns policy', type:'Support', href:'shipping-returns.html', img:'', d:'Free shipping across India. No fine-print games.'},
    {t:'Authenticity', k:'genuine sealed ifra batch', type:'Support', href:'authenticity.html', img:'', d:'Sealed at the house. Sold only direct.'}
  ];
  // THEME COPY: same sixteen entries, same words; only where they point changes.
  // Products -> /products/<handle> with the product's own image from window.MZ.products (layout/theme.liquid,
  // which already leaves the preorder deposit out); house pages -> /pages/<handle>.
  // "Gifts & Sets" is dropped: collection-gifting.html does not exist in the static draft either.
  if(window.Shopify && window.Shopify.shop){
    var P = (window.MZ && window.MZ.products) || {};
    INDEX = INDEX.filter(function(it){ return it.href !== 'collection-gifting.html'; });
    INDEX.forEach(function(it){
      var m = /^pdp-hero-(.+)\.html$/.exec(it.href);
      var handle = m ? m[1] : it.href === 'pdp-hero.html' ? 'rose-oclock'
                 : it.href === 'collection-discovery.html' ? 'discovery-set' : '';
      if(handle){ it.href = '/products/' + handle; it.img = (P[handle] && P[handle].image) || ''; }
      else it.href = '/pages/' + it.href.replace('.html', '');
    });
  }
  var results = [], activeIdx = -1;

  var PRODUCT_TYPES = {Epos:1, Oud:1, Cristallo:1, Set:1, Shop:1};
  function score(q, item){
    q = q.toLowerCase();
    var t = item.t.toLowerCase();
    var rel = 0;
    if(t.indexOf(q) === 0) rel = 90 + q.length;                     // title prefix
    else if((' ' + t).indexOf(' ' + q) > -1) rel = 70 + q.length;   // word prefix
    else if(t.indexOf(q) > -1) rel = 50;                            // substring
    else if(item.k.indexOf(q) > -1) rel = 25;                       // keyword
    if(rel === 0) return 0;
    return rel + (PRODUCT_TYPES[item.type] ? 8 : 0);                // product tiebreaker within band
  }
  function render(){
    var q = input.value.trim();
    list.innerHTML = ''; activeIdx = -1;
    ghost.textContent = '';
    document.getElementById('searchPreview').classList.remove('show');
    if(!q){ return; }
    results = INDEX.map(function(it){ return {it:it, s:score(q, it)}; })
      .filter(function(r){ return r.s > 0; })
      .sort(function(a,b){ return b.s - a.s; })
      .slice(0, 6).map(function(r){ return r.it; });
    // inline autofill ghost: first prefix match completes in place
    var first = results[0];
    if(first && first.t.toLowerCase().indexOf(q.toLowerCase()) === 0){
      ghost.textContent = q + first.t.slice(q.length);
    }
    results.forEach(function(it, i){
      var li = document.createElement('li');
      var strong = document.createElement('em'); strong.textContent = it.t;
      var tag = document.createElement('span'); tag.className = 's-type'; tag.textContent = it.type;
      li.appendChild(strong); li.appendChild(tag);
      li.addEventListener('click', function(){ goTo(it); });
      li.addEventListener('mouseenter', function(){ setActive(i); });
      list.appendChild(li);
    });
  }
  var spPrev = document.getElementById('searchPreview');
  var spImg = document.getElementById('spImg');
  var spDesc = document.getElementById('spDesc');
  function setActive(i){
    activeIdx = i;
    [].forEach.call(list.children, function(li, j){ li.classList.toggle('active', j === i); });
    var it = results[i];
    if(it){
      spImg.setAttribute('src', it.img || '');
      spDesc.textContent = it.d || '';
      spPrev.classList.add('show');
    } else {
      spPrev.classList.remove('show');
    }
  }
  function goTo(it){
    setSearch(false);
    if(it.href && it.href !== '#') location.href = it.href;
  }
  function setSearch(open){
    overlay.classList.toggle('open', open);
    if(open){ input.value=''; ghost.textContent=''; list.innerHTML=''; setTimeout(function(){ input.focus(); }, 60); }
  }

  input.addEventListener('input', render);
  input.addEventListener('keydown', function(e){
    if(e.key === 'ArrowDown'){ e.preventDefault(); if(results.length) setActive(Math.min(activeIdx+1, results.length-1)); }
    else if(e.key === 'ArrowUp'){ e.preventDefault(); if(results.length) setActive(Math.max(activeIdx-1, 0)); }
    else if(e.key === 'ArrowRight' || e.key === 'Tab'){
      if(ghost.textContent && input.selectionStart === input.value.length){
        e.preventDefault(); input.value = ghost.textContent; render();
      }
    }
    else if(e.key === 'Enter'){
      if(activeIdx > -1) goTo(results[activeIdx]);
      else if(results.length) goTo(results[0]);
    }
    else if(e.key === 'Escape'){ setSearch(false); }
  });
  overlay.addEventListener('click', function(e){ if(e.target === overlay) setSearch(false); });
  document.getElementById('searchClose').addEventListener('click', function(){ setSearch(false); });
  document.getElementById('menuSearch').addEventListener('click', function(e){
    e.preventDefault(); e.stopPropagation();
    document.getElementById('mobileMenu').classList.remove('open');
    document.getElementById('navBurger').setAttribute('aria-expanded','false');
    setSearch(true);
  });
})();
